<template>
    <section id="services" class="services-section" aria-label="Nossos serviços">
        <div class="services-content">
            <header class="section-header">
                <span class="section-tag">Serviços</span>
                <h2 class="section-title-modern">
                    Soluções para operações que não podem depender de improviso.
                </h2>
                <p class="section-description">
                    Atuamos do diagnóstico à sustentação, com desenvolvimento sob medida para processos internos,
                    integrações e rotinas críticas em diferentes segmentos, com especial profundidade no setor jurídico.
                </p>
            </header>

            <v-row class="services-grid">
                <v-col v-for="(item, index) in items" :key="index" cols="12" sm="6" md="4">
                    <article class="service-card">
                        <div class="service-card-icon" aria-hidden="true">
                            <v-icon size="26" color="#111111">{{ item.icon }}</v-icon>
                        </div>
                        <h3 class="service-card-title">{{ item.title }}</h3>
                        <p class="service-card-text">{{ item.description }}</p>
                    </article>
                </v-col>
            </v-row>
        </div>
    </section>
</template>

<script>
export default {
    data() {
        return {
            items: [
                {
                    icon: "mdi-file-document-edit-outline",
                    title: "Sistemas internos sob medida",
                    description: "Criamos plataformas alinhadas à rotina real da operação, com regras, permissões e fluxos desenhados para cada contexto.",
                },
                {
                    icon: "mdi-cog-sync-outline",
                    title: "Automação de rotinas",
                    description: "Reduzimos tarefas repetitivas e pontos de falha manual em processos operacionais, administrativos, jurídicos e financeiros.",
                },
                {
                    icon: "mdi-source-branch",
                    title: "Integração entre plataformas",
                    description: "Conectamos sistemas existentes para centralizar informações, eliminar retrabalho e manter dados consistentes.",
                },
                {
                    icon: "mdi-chart-box-outline",
                    title: "Dashboards operacionais",
                    description: "Organizamos indicadores e visões gerenciais para apoiar acompanhamento, prestação de contas e tomada de decisão.",
                },
                {
                    icon: "mdi-shield-check-outline",
                    title: "Sustentação de sistemas críticos",
                    description: "Evoluímos e mantemos aplicações com atenção à estabilidade, continuidade e segurança da operação.",
                },
                {
                    icon: "mdi-account-tie-outline",
                    title: "Consultoria técnica",
                    description: "Apoiamos decisões de arquitetura, migração, priorização e desenho de soluções digitais para cenários complexos.",
                },
            ],
        };
    },
};
</script>

<style lang="scss">
.services-section {
    position: relative;
    background: #f4f4f2;
    padding: 112px 0;
    border-bottom: 1px solid #ddddda;
    overflow: hidden;
}

.services-content {
    width: 75%;
    margin: 0 auto;
}

.section-header {
    text-align: center;
    margin: 0 auto 70px;
    max-width: 760px;
}

.services-grid {
    margin: 0 -12px;
}

.service-card {
    position: relative;
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 286px;
    padding: 34px 30px;
    background: #ffffff;
    border: 1px solid #ddddda;
    border-radius: 4px;
    transition: background 0.25s ease, border-color 0.25s ease;
}

.service-card:hover {
    background: #ffffff;
    border-color: #242424;
}

.service-card-icon {
    width: 52px;
    height: 52px;
    border: 1px solid #d0d0cc;
    background: #f1f1ee;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 28px;
}

.service-card-title {
    font-family: "Space Grotesk", sans-serif !important;
    color: #111111;
    font-size: 19px;
    font-weight: 700;
    line-height: 1.25;
    margin-bottom: 14px;
}

.service-card-text {
    color: #5f5f59;
    font-size: 14px;
    line-height: 1.7;
    margin: 0;
}

@media (max-width: 960px) {
    .services-content {
        width: 90%;
    }
}
</style>
